module.exports = __webpack_public_path__ + "img/building95-1.0abdc877.jpg";